import { render, staticRenderFns } from "./FbQuiz.vue?vue&type=template&id=750eda38"
import script from "./FbQuiz.vue?vue&type=script&lang=js"
export * from "./FbQuiz.vue?vue&type=script&lang=js"
import style0 from "./FbQuiz.vue?vue&type=style&index=0&id=750eda38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports